<template>
	<div>
		<div v-for="(setup, index) in setups" :key="index">
			<form action="/dettagli" method="POST" ref="bikeEquipment" class="bike_list_descr">
				<input type="hidden" name="_token" :value="csrfToken" />
				<input type="hidden" name="codiceInfobikePRG" v-model="setup.codiceInfobikePRG" />
				<input type="hidden" name="quotation_id" :value="quotation_id" />

				<div class="bike_list_cont">
					<button v-if="isMobile" type="submit">
						<div class="bike-title">
							{{ setup.nome }}
							<img src="../../../images/project-img/Arrow-Big-right.png" width="10" alt="" />
						</div>
					</button>

					<div v-else-if="!isMobile" class="bike-title">
						<button type="submit" class="btn-bike-title">
							{{ setup.nome }}
							<!-- <img src="../../../images/project-img/Arrow-Big-right.png" width="10" alt=""/> -->
						</button>
					</div>

					<div class="bike-descr">
						<div class="row_descr">
							<div>
								<span class="label-bold">Sul mercato dal:</span>
								<span>{{ setup.inizioVendita }} al {{ setup.fineVendita }}</span>
							</div>
						</div>
						<div class="odd-desk row_descr">
							<div class="single-row">
								<span class="label-bold">Cilindrata:</span>
								<span>{{ setup.cilindrata }}</span>
							</div>
							<div>
								<span class="label-bold">Potenza Kw/CV:</span>
								<span>{{ setup.potenza }}</span>
							</div>
						</div>
						<div class="row_descr">
							<div class="single-row">
								<span class="label-bold">Cambio:</span>
								<span>{{ setup.cambio }}</span>
							</div>
							<div>
								<span class="label-bold">Normativa Euro:</span>
								<span>{{ setup.normativaEuro }}</span>
							</div>
						</div>
						<div class="odd-desk row_descr">
							<div>
								<span class="label-bold">Freno anteriore / posteriore:</span>
								<span>{{ setup.freno }}</span>
							</div>
						</div>
					</div>
				</div>
				<button type="submit" class="mobile-d-none">
					<img src="../../../images/project-img/Arrow-Big-right.png" width="10" alt="" title="Scegli l’allestimento" />
				</button>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	name: 'BikeEquipment',
	props: {
		quotation_id: {
			type: Number,
			required: true,
		},
		setups: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			isMobile: false, // Stato che verifica se è un dispositivo mobile
		};
	},
	methods: {
		checkIfMobile() {
			this.isMobile = window.innerWidth <= 768; // Imposta isMobile a true se la larghezza è <= 768px
		},
	},
	mounted() {
		// Controlla lo stato al montaggio del componente
		this.checkIfMobile();
		// Aggiungi un listener per aggiornare lo stato su resize
		window.addEventListener('resize', this.checkIfMobile);
	},
	beforeDestroy() {
		// Rimuovi il listener per evitare problemi di memoria
		window.removeEventListener('resize', this.checkIfMobile);
	},
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/BikeEquipment.vue